<template>
    <div v-if="folder" class="folder-view">
        <div id="folder-view-header">
            <span id="folder-view-title">
                {{folder.name}}
            </span>
            <span id="folder-view-button">
                <i class="fas fa-trash fa" @click="show_delete_modal=true"/>
            </span>
        </div>

        <div id="folder-view-content">
            <div id="recently-edited" class="quick-section">
                <div v-for="note in recentNotes" :key="note.slug" class="note">
                    <div class="note-header">
                        <router-link :to="`/${current_workspace.slug}/notes/${note.slug}`" class="link note-title">
                            {{note.title}}
                        </router-link>
                        <span class="note-updated-at">
                            {{ getDateTimeFromMilliseconds(note.updated_at) || '2020-04-20 16:35'}}
                        </span>
                    </div>

                    <span v-if="note.text.length" class="note-content">
                        {{getTextFromMarkdown(note.text)}}
                    </span>
                </div>
                <div v-if="!notes.length">
                    You haven't edited any notes recently.
                </div>
            </div>


            <div id="folder-contents" class="quick-section">
                <div v-for="note in notes" :key="note.slug" class="note">
                    <div class="note-header">
                        <router-link :to="`/${current_workspace.slug}/notes/${note.slug}`" class="link note-title">
                            {{note.title}}
                        </router-link>
                        <span class="note-updated-at">
                            {{getDateTimeFromMilliseconds(note.updated_at) || '2020-04-20 16:35'}}
                        </span>
                    </div>

                    <span v-if="note.text.length" class="note-content">
                        {{getTextFromMarkdown(note.text)}}
                    </span>
                </div>
                <div v-if="!notes.length">
                    You don't have any notes yet. <router-link to="/new"> Create one now?</router-link>
                </div>
            </div>
        </div>

        <div v-if="show_delete_modal" class="delete-folder-modal">
            <div>
                <div class="header">
                    Delete

                    <i class="fas fa-times close-button" @click="show_delete_modal=false"/>
                </div>
                <div class="body">
                    Are you sure you want to  <strong>permenantly delete this folder and  all of its notes</strong>?
                </div>
                <div class="footer">
                    <div class="button icon-button" @click="show_delete_modal=false">Cancel</div>
                    <div class="button icon-button" @click="deleteFolder">Yes</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import RemoveMarkdown from 'remove-markdown';

export default {
    data() {
        return {
            show_delete_modal: false
        }
    },
    methods: {
        getTextFromMarkdown(markdown) {
            return RemoveMarkdown(markdown);
        },

        deleteFolder() {
            this.$store.dispatch('deleteFolderFromWorkspace', this.folder.slug).then(folder => {
                this.$router.push('/');
            });
        },

        getDateTimeFromMilliseconds(milliseconds) {
            var dateString;

            if (milliseconds != null) {
                dateString = new Date(milliseconds);
            }
            else {
                dateString = new Date('2020-04-20 16:35');
            }

            return dateString.toUTCString();
        }
    },
    computed: {
        current_workspace() {
            return this.$store.getters.current_workspace;
        },

        folder() {
            return this.$store.getters.folder_with_slug(this.$route.params.folder_route)
        },

        workspaces() {
            return Object.values(this.$store.getters.workspaces);
        },

        notes() {
            if (!this.folder) return null;
            return Object.values(this.$store.getters.notes).filter(note => note.parent_slug === this.folder.slug);
        },

        recentNotes() {
            if (!this.folder) return null;
            var notes = Object.values(this.$store.getters.notes).filter(note => note.parent_slug === this.folder.slug );
            var sortedNotes = notes.filter(note => note.updated_at != null).sort(            
                function(a, b){
                    return b.updated_at-a.updated_at
            });        
            return sortedNotes.slice(0, 5); 
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "../assets/colors";

    .folder-view 
        position: relative;

    #folder-view-header
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        font-size: 2em;

    #folder-view-content
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 25px 100px 0px 100px;
        // margin-bottom: -50px;
        @media only screen and (max-width: 720px) 
            padding: 5px 20px 0px 20px;

    .note
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;

        width: calc(100% + 30px);
        margin: 0 -15px;
        padding: 5px 15px;

        color: $faded-light-text;
        background-color: inherit;
        
        flex-grow: 1
        flex-shrink: 1

        &:nth-child(odd)
            background-color: darken($darker-bg, 2%);

    .note-header
        display: flex
        justify-content: space-between
        align-items: flex-start

    .note-updated-at
        color: $faded-light-text
        font-size: 10px;
        padding: 3px;
        padding-left: 30px;
            
        
    .note-title, .action
        color: $accent-bg;

    .note-content
        color: $faded-light-text;
        opacity: 0.5
        font-size:  0.8em
        flex-shrink: 1
        max-height: 60px
        transition: opacity 0.3s ease
        display: -webkit-box
        -webkit-line-clamp: 3
        -webkit-box-orient: vertical
        overflow: hidden

        &:hover
            opacity: 1

    .delete-folder-modal
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #0004
        display: flex;
        justify-content: center
        align-items: flex-start
        
        > div
            background-color: darken($darker-bg, 5%);
            margin: 20% 50px
            margin-bottom: 0px

        .header
            position: relative;
            padding: 5px;
            vertical-align: middle;
            i
                position: absolute;
                right: 10px;
                padding: 5px;
        .body
            padding: 20px

        .footer
            display: flex
            justify-content: flex-end
            padding: 10px 10px
            .button
                padding: 5px 10px 
                max-width: unset
                margin-left: 10px
    
    .quick-section
        border: 1px solid $border-medium;
        border-radius: 5px;
        padding: 15px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        flex: 0.4;
        flex-grow: 2
        // width: 100%;
        margin-bottom: 50px;
        background-color: $darker-bg;
        box-shadow: $card-shadow;
        text-align: left;
        position: relative;

        &#recently-edited::before
            content: 'Recently Edited';
        &#folder-contents::before
            content: 'Folder Contents';

        &::before
            position: absolute;
            left: 5px;
            bottom: calc(100% + 5px);
            height: 10px;
            font-size: 10px;
            color: $light-text;
            opacity: 0.7;
        @media only screen and (max-width: 720px) 
            margin-bottom: 25px;
        
</style>
